export default __webpack_public_path__ + "static/media/category-02.63470095.svg";